import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './relatedProducts.css';
import Item from '../items/item';
import { ShopContext } from '../../context/shopContext';

const RelatedProducts = ({ product }) => {
  const { allProducts } = useContext(ShopContext);

  const category = product?.occasion?.[0] || null;

  const relatedProducts = allProducts.filter(
    (item) => category && item.occasion?.includes(category) && item.id !== product?._id
  );

  const additionalProducts = allProducts.filter(
    (item) => !relatedProducts.includes(item) && item.id !== product?._id
  );

  const finalProducts = [...relatedProducts, ...additionalProducts].slice(0, 4);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!product) {
    return <div>Loading related products...</div>;
  }

  return (
    <div className="related-products">
      <div className="titles">
        <div>
          <h2>Related Products</h2>
          <p>Other stuff your friends might (not) like</p>
        </div>
        <div className="shop-all-button">
          <Link to="/all">
            <p>Shop all</p>
          </Link>
        </div>
      </div>
      <div className="related-products-item">
        {finalProducts.map((item, i) => (
          <Item
            key={i}
            id={item.id}
            name={item.name}
            image={item.image}
            new_price={item.new_price}
            old_price={item.old_price}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;
